// extracted by mini-css-extract-plugin
export default {"download-message":"download-container_download-message__ZwnhO","download-container":"download-container_download-container__-05xZ"};